'use strict';

var Params = function Params(width, containerWidth, containerHeight) {
  var padding = {
    top: 10,
    bottom: 50,
    left: 72,
    right: 20
  };
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    yNumberOfTicks: 5,
    yAxisShift: 6,
    yAxisLabelShift: 62,
    forceWidth: true
  };
};
module.exports = Params;